import React, { PureComponent } from 'react';

import { Edit as EditIcon, Delete as DeleteIcon, Refresh as UpdateIcon } from '@mui/icons-material';

import { IconButton, Tooltip, Zoom } from '@mui/material';

import TableEnhancedContainer from '../../../../common/components/TableEnhanced/TableEnhancedContainer';
import ConfirmationDialog from '../../../../common/components/ConfirmationDialog/ConfirmationDialog';
import CreationDialog from '../CreationDialog/CreationDialog';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';

class FleetsView extends PureComponent {
  constructor(props) {
    super(props);
    this.columnsConfig = [
      {
        name: 'Name',
        key: 'Name',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'No of instruments',
        key: 'NumberOfInstruments',
        type: 'number',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Actions',
        key: 'Actions',
        type: 'markup',
        markup: (el, col, elIndex, colIndex) => {
          return (
            <div>
              <Tooltip disableInteractive TransitionComponent={Zoom} title="Update">
                <IconButton
                  size="large"
                  button
                  component="span"
                  key={elIndex}
                  data-qa="qa-update"
                  onClick={(event) => {
                    return props.onUpdateCallback(event, el);
                  }}
                >
                  <UpdateIcon />
                </IconButton>
              </Tooltip>
              <Tooltip disableInteractive TransitionComponent={Zoom} title="Edit">
                <IconButton
                  size="large"
                  button
                  component="span"
                  key={elIndex}
                  data-qa="qa-edit"
                  onClick={(event) => {
                    return props.onEditCallback(event, el);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                <IconButton
                  size="large"
                  key={elIndex}
                  data-qa="qa-delete"
                  onClick={(event) => {
                    return props.onDeleteCallback(event, el);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        style: { width: '15rem' },
        visible: true,
        filterable: false,
        sortable: false,
      },
    ];
  }

  render() {
    return (
      <div>
        <ConfirmationDialog
          onClickCancel={this.props.showConfirmDialog.cancel}
          onClickMainAction={this.props.showConfirmDialog.action}
          open={this.props.showConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirm}
          title={this.props.showConfirmDialog.title}
          mainActionLabel={this.props.showConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showConfirmDialog.disableMainAction}
        />

        <CreationDialog
          onClickCancel={this.props.showDialog.cancel}
          onClickMainAction={this.props.showDialog.action}
          open={this.props.showDialog.show}
          title={this.props.showDialog.title}
          disableMainAction={
            !(this.props.errorFleetName === '' && this.props.fleetName && !this.props.isFetching)
          }
          textfieldName={'Fleet name'}
          errorText={this.props.errorFleetName}
          onChangeCallback={this.props.onChangeCallback}
          propertyToEdit={'Name'}
        />

        <PermissionsCheck permission={PermissionsEnum.VIEW_FLEETDETAILS}>
          <TableEnhancedContainer
            data={this.props.fleetsList}
            columns={this.columnsConfig}
            enableHideColumns={false}
            enableActionButtons={false}
            onClickRow={this.props.onFleetRowSelected}
            data-qa="qa-table-fleets"
          />
        </PermissionsCheck>

        <PermissionsCheck permission={PermissionsEnum.VIEW_FLEETDETAILS} hasPermission={false}>
          <TableEnhancedContainer
            data={this.props.fleetsList}
            columns={this.columnsConfig}
            enableHideColumns={false}
            enableActionButtons={false}
            data-qa="qa-table-fleets"
          />
        </PermissionsCheck>
      </div>
    );
  }
}

export default FleetsView;
